import defaultHttpClient from 'hub-http/clients/apiClient';
import type { HubHttpClient } from '../../../HttpClientContext';

export type SessionInfoResponse = {
  status: 'PENDING' | 'AUTH_RESPONSE';
  params?: {
    [key: string]: string;
  };
};

/**
 * Fetches the session info for the given `sessionId`.
 * This is used to check the status of the authentication flow.
 *
 * @param httpClient - Optional HTTP client override. Defaults to
 *   `hub-http/clients/apiClient` (portal-session auth). Pass a custom client
 *   for non-portal contexts (e.g. Janus IDP stacks).
 */
export function fetchSessionInfo(
  portalId: number,
  sessionId: string,
  httpClient: HubHttpClient = defaultHttpClient
) {
  return httpClient
    .get<SessionInfoResponse>(
      `/api/unified-auth/v1/authenticators/session/${sessionId}`,
      {
        query: { portalId },
      }
    )
    .then((response: SessionInfoResponse) => ({
      ...response,
      params: new Map(Object.entries(response.params || {})),
    }));
}
